module.exports = __webpack_public_path__ + "static/img/btn_tongxunlu_nor.25e715a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_tongxunlu_nor.png
// module id = RLJW
// module chunks = 1